<template>
	<div class="con">
		<div class="head">
			<div class="head-bot">
				<van-tabs v-model="headActive" @change='staOnChange' color="#27bec4">
					<van-tab title="总览"></van-tab>
					<van-tab title="门诊"></van-tab>
					<van-tab title="住院"></van-tab>
				</van-tabs>
			</div>
		</div>
		<div class="time-quantum">
			<van-cell title="选择日期时间段" :value="date" @click="show = true" />
			<van-calendar v-model="show" type="range" :default-date="defaTime" @confirm="onConfirm" :min-date="minDate"
			 :max-date="maxDate" color="#43c6cb" />
		</div>
		<div class="total-con" v-if="noImgShow == false">
			<div class="total-title">
				<div class="total-title-left">总收入</div>
				<div class="total-title-right">(单位：元)</div>
			</div>
			<div class="total-num">
				<div class="total-left">
					<div class="totol-max">{{list.HZ_JE}}</div>
					<div class="totol-min">环比：{{list.HZ_JEHB_L}}</div>
					<div class="totol-min">同比：{{list.HZ_JETB_L}}</div>
				</div>
				<div class="total-right">
					<div class="t-r-back">
						<div class="t-r-title">门诊收入</div>
						<div class="total-r-text">
							<div class="t-r-num">{{list.MZ_HZ_JE}}</div>
							<div>
								<div class="totol-min">环比：{{list.MZ_HZ_JEHB}}</div>
								<div class="totol-min">同比：{{list.MZ_HZ_JETB}}</div>
							</div>
						</div>
					</div>
					<div class="t-r-back">
						<div class="t-r-title">住院收入</div>
						<div class="total-r-text">
							<div class="t-r-num">{{list.ZY_HZ_JE}}</div>
							<div>
								<div class="totol-min">环比：{{list.ZY_HZ_JEHB}}</div>
								<div class="totol-min">同比：{{list.ZY_HZ_JETB}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="list">

				<div class="list-con">
					<div class="list-c-title">
						<div class="list-c-text">药品总金额</div>
						<div class="list-c-num">{{list.HZ_YPJE}}</div>
					</div>
					<div class="list-c-title">
						<div class="list-proportion">金额环比：<span>{{list.HZ_YPJEHB}}({{list.HZ_YPJEHB_L}})</span></div>
						<div class="list-proportion">金额同比：<span>{{list.HZ_YPJETB}}({{list.HZ_YPJETB_L}})</span></div>
					</div>
				</div>

				<div class="list-con">
					<div class="list-c-title">
						<div class="list-c-text">项目总金额</div>
						<div class="list-c-num">{{list.HZ_XMJE}}</div>
					</div>
					<div class="list-c-title">
						<div class="list-proportion">项目环比：<span>{{list.HZ_XMJEHB}}({{list.HZ_XMJEHB_L}})</span></div>
						<div class="list-proportion">项目同比：<span>{{list.HZ_XMJETB}}({{list.HZ_XMJETB_L}})</span></div>
					</div>
				</div>

				<div class="list-con">
					<div class="list-c-title">
						<div class="list-c-text">材料总金额</div>
						<div class="list-c-num">{{list.HZ_CLJE}}</div>
					</div>
					<div class="list-c-title">
						<div class="list-proportion">材料环比：<span>{{list.HZ_CLJEHB}}({{list.HZ_CLJEHB_L}})</span></div>
						<div class="list-proportion">材料同比：<span>{{list.HZ_CLJETB}}({{list.HZ_CLJETB_L}})</span></div>
					</div>
				</div>

			</div>
		</div>
		<div class="noImg" v-if="noImgShow == true">
			<img src="../assets/404.gif" />
			<div class="no-text">无清单列表~~</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'statistical',
		data() {
			return {
				headActive: 0,
				date: '',
				show: false,
				minDate: '',
				maxDate: '',
				Choose: '',
				defaTime: '',
				list: [],
				noImgShow: false,
			}
		},
		methods: {
			GetHzDataReport() {
				this.$store.commit('Load', true)
				this.$Axios.Get('/other/getHzDataReport?startDate=' + this.Choose[0] + '&endDate=' + this.Choose[1], null).then(res => {
					console.log(res)
					this.$store.commit('Load', false)
					if (res.code == 0) {
						this.list = res.msg;
					} else {
						this.noImgShow = true
					}
				}).catch(err => {
					this.$store.commit('Load', false)
					console.log(err)
					this.noImgShow = true
				})
			},
			//导航
			staOnChange(event) {
				if (event == 1) {
					this.$router.replace({
						path: '/staOutpatient'
					})
				} else if (event == 2) {
					this.$router.replace({
						path: '/stainHospital'
					})
				}
			},
			formatDate(date) {
				return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
			},
			onConfirm(date) {

				const [start, end] = date;
				this.show = false;
				this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;
				this.deChoose = [start, end];

				this.GetHzDataReport();
				this.noImgShow = false;
			},
			//时间段
			timeQuantum() {
				let newT = new Date();
				let minT = newT - 1000 * 60 * 60 * 24 * 30 * 12 * 5; //只能查当前时间 往前的5年信息

				this.maxDate = newT;
				this.minDate = new Date(minT);

				let newYear = newT.getFullYear() + "/1/1";

				this.defaTime = [new Date(newYear), new Date()]
				this.date = `${this.formatDate(new Date(newYear))} - ${this.formatDate(new Date())}`;
				this.Choose = [`${this.formatDate(new Date(newYear))}`, `${this.formatDate(new Date())}`]

				this.GetHzDataReport();
			},
		},
		mounted() {},
		created() {
			this.timeQuantum();
		},
	}
</script>

<style scoped>
	.con {
		width: 100%;
		height: 100%;
	}

	.time-quantum {
		margin: 10px 0;
		background-color: #f0f0f0;
	}

	.total-con {
		padding: 10px;
		background-color: #fff;
	}

	.total-title {
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.total-title-left {
		font-weight: 700;
		font-size: 18px;
		color: #000;
	}

	.total-title-right {
		font-size: 14px;
		color: #999;
	}

	.total-num {
		display: flex;
		justify-content: space-around;
		align-items: center;
		padding: 10px 5px;
		color: #fff;
		background: #27bec4;
		border-radius: 5px;
	}

	.total-left {
		width: 50%;
	}

	.totol-max {
		margin: 30px 0;
		font-size: 26px;
		font-weight: 700;
	}

	.totol-min {
		margin: 10px 0;
		font-size: 12px;
	}

	.t-r-back {
		padding: 5px;
		margin: 5px 0;
		border-radius: 5px;
		background-color: rgba(255, 255, 255, 0.2);
	}

	.t-r-title {
		font-size: 14px;
	}

	.total-r-text {
		display: flex;
		align-items: center;
	}

	.t-r-num {
		margin-right: 20px;
		font-size: 20px;
	}

	.list-con {
		padding: 10px;
		margin: 10px 0;
		color: #333;
	}

	.list-c-title {
		display: flex;
		justify-content: space-between;
		padding: 5px 0;
	}

	.list-c-text {
		font-size: 14px;
		font-weight: 700;
	}

	.list-c-num {
		font-size: 20px;
		font-weight: 700;
		color: red;
	}

	.list-proportion {
		font-size: 12px;
		font-weight: 700;
	}

	.list-proportion span {
		color: #27BEC4;
	}

	.noImg {
		margin-top: 10vh;
		text-align: center;
	}

	.no-text {
		margin-top: 10px;
		color: #27BEC4;
		font-size: 16px;
	}
</style>
